import React, { useState, useEffect } from 'react';
import { useMyContext } from '../../../../context/MyContext';

import NavBar from '../../../../component/b2c/navBar/navBar';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import axios from 'axios';
import { PiWarehouseFill } from "react-icons/pi";
import { toast } from 'react-toastify';
import '../../../../css/custom-scrollbar.css';
import { Addwarehouse, Base_Url, getpincode, fetchUser } from '../../../../config/config';
import { useNavigate } from 'react-router-dom';
import Select from "react-dropdown-select";

const schema = z.object({
  facilityName: z.string()
    .min(1, "Facility name is required")
    .regex(/^[A-Za-z\s]+$/, "Facility name must only contain letters and spaces"),
  // pincode: z.string()
  //   .min(6, "Pincode should be at least 6 characters")
  //   .max(6, "Pincode should be at most 6 characters")
  //   .regex(/^\d+$/, "Pincode must be numeric"),
  contactPerson: z.string()
    .min(1, "Contact Person  is required")
    .regex(/^[A-Za-z\s]+$/, " Contact Person must only contain letters and spaces"),
  // city: z.string()
  //   .min(1, "City is required")
  //   .regex(/^[A-Za-z\s]+$/, "City must only contain letters and spaces"),
  phone: z.string()
    .length(10, "Phone number must be exactly 10 digits")
    .regex(/^\d+$/, "Phone number must be numeric"),
  // state: z.string()
  //   .min(1, "State is required")
  //   .regex(/^[A-Za-z\s]+$/, "State must only contain letters and spaces"),
  pincode: z.string()
    .min(6, "Pincode should be exactly 6 characters")
    .max(6, "Pincode should be exactly 6 characters")
    .regex(/^\d+$/, "Pincode must be numeric"),
  city: z.string().min(1, "City is required").regex(/^[a-zA-Z\s]+$/, "City must only contain alphabetic characters"),
  state: z.string().min(1, "State is required").regex(/^[a-zA-Z\s]+$/, "State must only contain alphabetic characters"),
  email: z.string().optional(),
  // address: z.string().min(1, "Address is required"),
  address: z
  .string()
  .min(1, "Address is required")
  .regex(/^[^#\\%&;]*$/, "Address contains invalid characters (# \\ % & ; not allowed)"),
  returnAddress: z.string().optional(),
  returnState: z.string().optional(),
  returnCity: z.string().optional(),
  returnCountry: z.string().optional(),
  returnPincode: z.string().optional()
});

const AddWarehouse = () => {
  const [showReturnAddress, setShowReturnAddress] = useState(false);
  const { isToggleSidebar, isDarkMode } = useMyContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [reatilerId, setRetailerId] = useState('')
  const [retailerIdData, setRetailerIdData] = useState([]);
  const role = localStorage.getItem("role");
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue
  } = useForm({
    resolver: zodResolver(schema),
  });


  const onErrors = (errors) => {
    toast.error("Please fix the errors in the form.");
  };

  const handleInputChange = (event) => {
    const { value, id } = event.target;

    if (['pincode', 'phone', 'return-pincode'].includes(id)) {
      const filteredValue = value.replace(/[^0-9]/g, '');
      event.target.value = filteredValue;

      // Trigger API call if input reaches 6 digits for `return-pincode`
      if (id === 'return-pincode' && filteredValue.length === 6) {
        fetchreturnPincodeData(filteredValue);
      }
      if (id === "pincode") {
        if (filteredValue.length < 6) {
          setValue("city", "");
          setValue("state", "");
        } else if (filteredValue.length === 6) {
          fetchPincodeData(filteredValue);
        }
      }
    }
    if (['facility-name', 'city', 'contact-person', 'state', 'returnState', 'returnCity', 'returnCountry', 'country'].includes(id)) {
      const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
      event.target.value = filteredValue;

    }
  };

  const navigate = useNavigate();
  const navigate1 = useNavigate();

  const naviagation = () => {
    navigate('/dashboard');
  }

  // const pincode = watch("pincode");
  // const returnPincode = watch("returnPincode")

  useEffect(() => {
    fetchReatiler();
  }, []);

  const fetchPincodeData = async (pincode) => {
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const urlgetPincode = `${Base_Url}${getpincode}?pincode=${pincode}`;
    try {
      const response = await fetch(urlgetPincode, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data && data.status === "SUCCESS") {
        let { city, state } = data.data[0];

        city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
        state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();
        setValue("city", city);
        setValue("state", state);
      }


      else if (data && data.message === "Unauthorized access - Invalid token") {
        // toast.error(data.message + " Please login Again");
      }

      else if (data && data.status === "FAIL") {
        toast.error("Something Went Wrong Please Try Again With Another Pincode");
      }


      else {
        toast.error("Failed to fetch city and state data");
      }
    } catch (error) {
      console.error('Error fetching pincode data:', error);
      toast.error("Error fetching pincode data");
    }
  };

  const fetchreturnPincodeData = async (returnPincode) => {
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const urlgetPincode = `${Base_Url}${getpincode}?pincode=${returnPincode}`;
    try {
      const response = await fetch(urlgetPincode, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cus_id,
          'Content-Type': 'application/json'
        }
      });


      const data = await response.json();
      if (data && data.status === "SUCCESS") {
        let { city, state } = data.data[0];

        city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
        state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();

        setValue("returnCity", city);
        setValue("returnState", state);
      }
      // else if (data && data.message === "Unauthorized access - Invalid token") {
      //   // toast.error(data.message + " Please login Again");
      // }

      else if (data && data.status === "FAIL") {
        toast.error("Something Went Wrong Please Try Again With Another Pincode");
      }
      else {
        toast.error("Failed to fetch city and state data");
      }
    } catch (error) {
      console.error('Error fetching pincode data:', error);
      toast.error("Error fetching pincode data");
    }
  };

  const onSubmit = async (data, event) => {
    event.preventDefault();
    const token = localStorage.getItem('token');
    let cusid = localStorage.getItem('cus_id');
    const adminId = localStorage.getItem('cus_id');
    setIsSubmitting(true);
    try {
      if (role == "admin") {
        cusid = reatilerId;
      } else {
        cusid = cusid;
      }
      const payload = {
        name: data.facilityName,
        email: data.email,
        phone: data.phone,
        address: data.address,
        pincode: data.pincode,
        city: data.city,
        contact_person: data.contactPerson,
        state: data.state,
        country: "India",
        customer_id: cusid,
        return_warehouse: showReturnAddress ? "true" : "false",
        return_address: data.returnAddress || '',
        return_city: data.returnCity || '',
        return_state: data.returnState || '',
        return_country: data.returnCountry || 'India',
        return_pincode: data.returnPincode || '',
      };

      const response = await axios.post(Base_Url + Addwarehouse, payload, {
        headers: {
          'token': token,
          'cus_id': adminId,
          'Content-Type': 'application/json',

        },
      });

      if (response.data.status === "SUCCESS") {
        toast.success(response.data.message);
        setIsSubmitting(false);
        setTimeout(() => {
          navigate1('/warehouse/all')
        })
      } else {
        throw new Error(response.data.message || 'Failed to save warehouse');
        setIsSubmitting(false);
      }
    } catch (error) {
      const errorMessagecontact_person = error.response?.data?.errors?.contact_person || "";
      const address = error.response?.data?.errors?.address || "";
      const email = error.response?.data?.errors?.email || "";
      const name = error.response?.data?.errors?.name || "";
      const return_country = error.response?.data?.errors?.return_country || "";
      const return_address = error.response?.data?.errors?.return_address || "";
      const return_pincode = error.response?.data?.errors?.return_address || "";
      const return_city = error.response?.data?.errors?.return_city || "";
      const return_state = error.response?.data?.errors?.return_city || "";
      const customer_id = error.response?.data?.errors?.customer_id || "";
      toast.error(errorMessagecontact_person || address || return_country || name || return_address || return_pincode || return_city || return_state || customer_id || email);
      setIsSubmitting(false);
    }
  };

  // fatch all reatlier for admin 
  const fetchReatiler = async () => {
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    const headers = new Headers({
      'token': token,
      'cus_id': cusid,
      'Content-Type': 'application/json'
    });

    try {
      const response = await fetch(Base_Url + fetchUser, {

        method: 'GET',
        headers: headers
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const transformedData = data.data.map(retailer => ({
        value: retailer.id,
        label: retailer.name,
      }));
      setRetailerIdData(transformedData)
    } catch (error) {
      console.error('Error:', error);
    }
  }

  // function for set the retailer id 

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    const selectedItem = retailerIdData.find((item) => item.value === selectedValue);
    if (selectedItem) {
      setRetailerId(selectedItem.value);
    } else {
      setRetailerId(""); // Optional: clear if no match
    }
  };


  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      <div className="z-10">
        <NavBar />
      </div>
      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div
            className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
            style={
              window.innerWidth < 768
                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                : {}
            }
          >
            <Sidebar />
          </div>
        )}
        <div className={`p-4 md:p-6 min-h-[50vh] custom-scrollbar overflow-y-auto dark:bg-darkmodeColor ${isToggleSidebar ? 'ml-0' : 'mr-0'} ${isToggleSidebar ? 'w-full' : 'w-full'} mb-8 md:mb-0 `}>
          <button onClick={naviagation}
            className="flex justify-center w-full items-center hover:bg-purple-700 mb-6 bg-customPurple text-white px-2 py-1 rounded-md hover:bg-customPurple-dark transition duration-300">
            <PiWarehouseFill className="text-xl text-white mr-2" />
            <h2 className="text-xl font-bold text-center">Add New Pickup Location</h2>
          </button>
          <form onSubmit={handleSubmit(onSubmit, onErrors)} className="  dark:bg-darkmodeColor dark:text-white shadow-custom-light  dark:shadow-custom-dark rounded-custom  px-8 pt-6 pb-8 mb-4 font-sans">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {role === 'admin' && (
                <div className="relative">
                  <label htmlFor="retailer" className="block text-xs mb-1 font-medium">Select Retailer</label>

                  <select
                    id="retailer"
                    className={`   p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${errors.facilityName ? 'border-red-500' : ''} ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                    onChange={handleSelectChange}
                  >
                    <option value="">Select Retailer</option>
                    {retailerIdData.map((item) => (
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>

                  {/* Dropdown arrow */}
                  <div className="pointer-events-none absolute inset-y-0 right-2 top-5 flex items-center">
                    <svg
                      className={`w-4 h-4 ${isDarkMode ? "text-white" : "text-darkmodeColor"}`}
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M7 7l3-3 3 3H7zm6 6l-3 3-3-3h6z" />
                    </svg>
                  </div>

                  {errors.warehouse && (
                    <p className="text-red-500 text-sm mt-1">{errors.warehouse.message}</p>
                  )}
                </div>

              )}
              <div>
                <label className="block text-xs mb-1 font-medium" htmlFor="facility-name">
                  Facility Name
                </label>
                <input
                  className={` p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${errors.facilityName ? 'border-red-500' : ''} ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                  id="facility-name"
                  type="text"
                  placeholder="Enter name"
                  {...register('facilityName')}
                  onChange={handleInputChange}
                />
                {errors.facilityName && <p className="text-red-500 text-xs italic">{errors.facilityName.message}</p>}
              </div>
              <div>
                <label className="block text-xs mb-1 font-medium" htmlFor="contact-person">
                  Contact Person
                </label>
                <input
                  className={` p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${errors.contactPerson ? 'border-red-500' : ''} ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                  id="contact-person"
                  type="text"
                  placeholder="Enter contact person name"
                  {...register('contactPerson')}
                  onChange={handleInputChange}
                />
                {errors.contactPerson && <p className="text-red-500 text-xs italic">{errors.contactPerson.message}</p>}
              </div>


              <div>
                <label className="block text-xs mb-1 font-medium" htmlFor="pincode">
                  Pincode
                </label>
                <input
                  className={` p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${errors.pincode ? 'border-red-500' : ''} ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                  id="pincode"
                  type="text"
                  maxLength="6"
                  placeholder="Enter pincode"
                  {...register('pincode')}
                  onChange={handleInputChange}
                />
                {errors.pincode && <p className="text-red-500 text-xs italic">{errors.pincode.message}</p>}
              </div>

              <div>
                <label className="block text-xs mb-1 font-medium" htmlFor="city">
                  City
                </label>
                <input
                  className={` p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${errors.city ? 'border-red-500' : ''} ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                  id="city"
                  type="text"
                  placeholder="Enter City"
                  {...register('city')}
                  disabled
                  onChange={handleInputChange}
                />
                {errors.city && <p className="text-red-500 text-xs italic">{errors.city.message}</p>}
              </div>
              <div>
                <label className="block text-xs mb-1 font-medium" htmlFor="state">
                  State
                </label>
                <input
                  className={` p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${errors.state ? 'border-red-500' : ''} ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                  id="state"
                  type="text"
                  placeholder="Enter state"
                  {...register('state')}
                  disabled
                  onChange={handleInputChange}
                />
                {errors.state && <p className="text-red-500 text-xs italic">{errors.state.message}</p>}
              </div>

              <div>
                <label className="block text-xs mb-1 font-medium" htmlFor="phone">
                  Pickup location phone
                </label>
                <input
                  className={` p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${errors.phone ? 'border-red-500' : ''} ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                  id="phone"
                  type="tel"
                  maxLength="10"
                  placeholder="Enter 10 digit mobile no."
                  {...register('phone')}
                  onChange={handleInputChange}
                />
                {errors.phone && <p className="text-red-500 text-xs italic">{errors.phone.message}</p>}
              </div>

              <div>
                <label className="block text-xs mb-1 font-medium" htmlFor="email">
                  Email
                </label>
                <input
                  className={` p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${errors.email ? 'border-red-500' : ''} ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                  id="email"
                  type="email"
                  placeholder="Enter email"
                  {...register('email')}
                />
                {/* {errors.email && <p className="text-red-500 text-xs italic">{errors.email.message}</p>} */}
              </div>
              <div>
                <label className="block text-xs mb-1 font-medium" htmlFor="country">
                  Country
                </label>
                <input
                  className={`placeholder-slate-600 p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${errors.country ? 'border-red-500' : ''} ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                  id="country"
                  type="text"
                  disabled
                  placeholder="India"
                  onChange={handleInputChange}
                />
              </div>
              <div>
                <label className="block text-xs mb-1 font-medium" htmlFor="address">
                  Address
                </label>
                <input
                  className={` p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${errors.address ? 'border-red-500' : ''} 
                ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                  id="address"
                  type="text"
                  placeholder="Enter complete address"
                  {...register('address')}
                />
                {errors.address && <p className="text-red-500 text-xs italic">{errors.address.message}</p>}
              </div>
            </div>

            <div className="mt-6">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={showReturnAddress}
                  onChange={(e) => setShowReturnAddress(e.target.checked)}
                  className="form-checkbox h-5 w-5 text-blue-600"
                />
                <span className="ml-2 font-bold">Different return address</span>
              </label>
            </div>
            {showReturnAddress && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                <div>
                  <label className="block text-xs mb-1 font-medium" htmlFor="return-address">
                    Return Address
                  </label>
                  <input
                    className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                    id="returnAddress"
                    type="text"
                    placeholder="Enter return address"
                    {...register('returnAddress')}
                  />
                </div>
                <div>
                  <label className="block text-xs mb-1 font-medium" htmlFor="return-country">
                    Return Country
                  </label>
                  <input
                    className={`placeholder-slate-600 p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                    id="returnCountry"
                    type="tel"
                    disabled
                    placeholder="India"
                    onChange={handleInputChange}
                  />
                </div>
                <div>
                  <label className="block text-xs mb-1 font-medium" htmlFor="return-pincode">
                    Return Pincode
                  </label>
                  <input
                    className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                    id="return-pincode"
                    type="text"
                    maxLength="6"
                    placeholder="Enter return pincode"
                    {...register('returnPincode')}
                    onChange={handleInputChange}

                  />
                </div>
                <div>
                  <label className="block text-xs mb-1 font-medium" htmlFor="return-city">
                    Return City
                  </label>
                  <input
                    className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                    id="returnCity"
                    type="text"
                    placeholder="Enter return City"
                    {...register('returnCity')}
                    onChange={handleInputChange}

                  />
                </div>
                <div>
                  <label className="block text-xs mb-1 font-medium" htmlFor="return-state">
                    Return State
                  </label>
                  <input
                    className={`p-1.5 text-xs appearance-none shadow-md rounded-custom border w-full focus:outline-none focus:shadow-outline ${isDarkMode ? "dark:bg-darkmodeColor text-white placeholder-white shadow-none" : ''}`}
                    id="returnState"
                    type="text"
                    placeholder="Enter return State"
                    {...register('returnState')}
                    onChange={handleInputChange}

                  />
                </div>

              </div>
            )}

            <div className="flex items-center justify-center mt-6">
              <button
                className="bg-customPurple hover:bg-purple-700 text-white font-bold py-1 px-2 rounded focus:outline-none focus:shadow-outline w-full"
                type="submit"
              >
                {isSubmitting ? "Creating Warehouse ...." : 'Create Warehouse'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddWarehouse;
